import { useState } from 'react';
import { ExternalLink, Copy } from 'lucide-react';
import McpConfigModal from '../mcp/McpConfigModal';
import OpenInIde from '../ide/OpenInIde';

interface Props {
    method: string;
    path: string;
    summary: string;
}

export default function AiShortcutMenu({ method, path, summary }: Props) {
    const [mcpOpen, setMcpOpen] = useState(false);

    const prompt = `Bantu saya pakai endpoint SatuTim ini:
${method} ${path} — ${summary}

Detail spec: https://playground.satutim.id (cari endpoint operationId yang sesuai).
Saya butuh contoh request body, cara handle response, dan edge cases yang perlu diperhatikan.`;

    const claudeUrl = `https://claude.ai/new?q=${encodeURIComponent(prompt)}`;
    const chatgptUrl = `https://chat.openai.com/?q=${encodeURIComponent(prompt)}`;

    return (
        <>
            <div className="flex flex-wrap items-center gap-2">
                <span className="text-xxs text-ghost">Atau buka di:</span>
                <a
                    href={claudeUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium text-ink transition-colors hover:bg-bg-hover"
                    style={{ backgroundColor: 'var(--surface-2)', border: '1px solid var(--border)' }}
                >
                    Claude <ExternalLink className="h-3 w-3 text-ghost" />
                </a>
                <a
                    href={chatgptUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium text-ink transition-colors hover:bg-bg-hover"
                    style={{ backgroundColor: 'var(--surface-2)', border: '1px solid var(--border)' }}
                >
                    ChatGPT <ExternalLink className="h-3 w-3 text-ghost" />
                </a>
                <button
                    onClick={() => setMcpOpen(true)}
                    className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium text-ink transition-colors hover:bg-bg-hover"
                    style={{ backgroundColor: 'var(--surface-2)', border: '1px solid var(--border)' }}
                >
                    <Copy className="h-3 w-3 text-ghost" /> Config MCP
                </button>
                <OpenInIde method={method} path={path} summary={summary} />
            </div>

            <McpConfigModal open={mcpOpen} onClose={() => setMcpOpen(false)} />
        </>
    );
}
